import BaseUtil from "../../util/BaseUtil";

const type = `@@ActionType/UPDATE@${__filename}`;

const initState = {
    isLoading: false,
    isEditing: false,
    interfaceUnitRelations: [],
    editInterfaceUnitRelations: [],
    unitRelationMappings: [],
    units: [],
    editUnits: [],
    relations: [],
    expandedRows: [],
    isRelationEditVisible: false,
    isEditingMap: {},
    platformDeptMap: {},
    buttonLoadingMap: {},
};

const [
    viewModel,
    update, reset,

] = BaseUtil.getViewModel(initState, type);

export {
    update,
    reset,
};

export default viewModel;
